const RING =
  "0 0 0 1px var(--tc-line-3), 0 0 0 5px var(--tc-paper), 0 0 0 6px var(--tc-brass-line), 0 12px 24px -12px rgba(0,0,0,.35)";

/** Circular avatar. Falls back to brass initials when no image is set. */
export function Avatar({ src, initials }: { src: string | null; initials: string }) {
  const base = { width: 94, height: 94, borderRadius: "50%", boxShadow: RING } as const;

  if (src) {
    return <img src={src} alt={initials} style={{ ...base, objectFit: "cover", display: "block" }} />;
  }
  return (
    <div
      style={{
        ...base,
        display: "grid",
        placeItems: "center",
        background: "radial-gradient(circle at 50% 35%, var(--tc-bg-1), var(--tc-paper-2))",
        fontFamily: "var(--tc-serif)",
        fontSize: 30,
        color: "var(--tc-brass)",
      }}
      aria-label={initials}
    >
      {initials}
    </div>
  );
}
